import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-marketplace-card',
  templateUrl: './marketplace-card.component.html',
  standalone: false
})

export class MarketplaceCardComponent {
  @Input() layout: 'horizontal' | 'vertical' = 'horizontal';
  @Input() icon: string;
  @Input() title: string;
  @Input() items: string[];
}